import Vue from 'vue';
Vue.component('app-back-btn', () => import('../mycomponents/Backbtn'));
Vue.component('app-calendar', () => import('../mycomponents/Calendar'));
Vue.component('app-list-hours', () => import('../mycomponents/Listhours'));
Vue.component('app-bid-hours', () => import('../mycomponents/Bidhours'));
Vue.component('app-alert', () => import('../mycomponents/Alert'));
Vue.component('app-confirm', () => import('../mycomponents/Confirm'));
Vue.component('app-my-currency', () => import('../mycomponents/MyCurrency'));
Vue.component('app-my-currency-simple', () => import('../mycomponents/MyCurrencySimple'));